<template>
<div class='bodyer recharge index'>
    <div class='yi-title-nav'>
        <div class='container'>
            <div class='row'>
                <div class='col-md-2 title'>
                    <i class='icon iconfont icon-chongzhi2 float-left'></i>充值应答币
                </div>
            </div>
        </div>
    </div>
    <div id='loop-banner' class='carousel slide loop-banner' data-interval='3000'>
        <div class='banner carousel-inner' style="height: 322px">
            <!--<div class='item active' style="height: 322px">
                <img src='/static/image/recharge/banner.jpg'>
            </div>-->
            <div class='item active'>
                <img src='/static/image/index/banner02.jpg' style="height: 322px;width: 100%">
            </div>
            <div class='item'>
                <img src='/static/image/index/banner03.jpg' style="height: 322px;width: 100%">
            </div>
            <div class='item'>
                <img src='/static/image/index/banner05.jpg' style="height: 322px;width: 100%">
            </div>
            <div class='item'>
                <img src='/static/image/index/ybcs_1.jpg' style="height: 322px;width: 100%">
            </div>
        </div>
        <a class='carousel-control left' href='#loop-banner'data-slide='prev'>
            <span class='glyphicon glyphicon-chevron-left'></span>
        </a>
        <a class='carousel-control right' href='#loop-banner'data-slide='next'>
            <span class='glyphicon glyphicon-chevron-right'></span>
        </a>
    </div>
    <div class='main'>
        <div class='container'>
            <div class='row'>
                <div class='col-md-9'>
                    <div class='yi-title'>
                        产品展示
                    </div>
                    <div class='list-game row'>
                        <div class='col-md-4' v-for='item in games' @click='toUrl("/recharge/redeem-game", item.id)'>
                            <div class='game'>
                                <div class='banner'>
                                    <img :src='item.banner'>
                                </div>
                                <div class='name'>{{item.name}}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class='col-md-3'>
                    <div class='yi-title'>
                        快捷入口
                    </div>
                    <div class='box-nav'>
                        <div class='title'>应答币充值</div>
                        <div class='link' @click='toUrl("/recharge/pay?channel=ali")'>
                            <i class='icon iconfont icon-umidd17' style='color: #24C358'></i>
                            <span>支付宝充值</span>
                        </div>
                        <div class='link' @click='toUrl("/recharge/pay?channel=wx")'>
                            <i class='icon iconfont icon-qietu08' style='color:#44D0B6'></i>
                            <span>微信充值</span>
                        </div>
                        <div class='link' @click='toUrl("/recharge/log")'>
                            <i class='icon iconfont icon-jilu' style='color:#E655FD'></i>
                            <span>充值记录</span>
                        </div>
                        <div class='link' @click='callAbbr()'>
                            <i class='icon iconfont icon-dianhua-copy-copy-copy-copy' 
                                style='color: #008DD5'></i>
                            <span>在线客服</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script type="text/javascript">
import Common from '@/common/Common'
export default {
    data : function(){
        return {
            'games' : [
                {
                    'name' : 'M2神甲奇兵',
                    'banner' : '/static/image/game-banner-2.png',
                    'id' : 1
                },
                {
                    'name' : '富甲三国',
                    'banner' : '/static/image/game-banner-7.jpg',
                    'id' : 2
                },
                {
                    'name' : '佣兵传说',
                    'banner' : '/static/image/game-banner-8.jpg',
                    'id' : 3
                }
            ]
        }
    },
    props : ['user'],
    methods : {
        //打开链接
        toUrl : function(url, id){
            if(typeof(id) != "undefined" && id != 1) {
                //return false;
                return Common.toUrl("/recharge/pay?channel=ali")
            }
            Common.toUrl(url)
        },
        callAbbr : function(){
            Common.callAbbr()
        }
    },
    created : function(){
        window.scrollTo(0, 0)
    }
}
</script>



// WEBPACK FOOTER //
// src/components/recharge/Index.vue